/* 🤖 this file was generated by svg-to-ts*/
export const icoPlay: {
  name: 'play';
  data: string;
} = {
  name: 'play',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 5v14c0 .86 1.012 1.318 1.659.753l8-7a1 1 0 000-1.506l-8-7C8.011 3.682 7 4.141 7 5zm2 2.204L14.481 12 9 16.795V7.204z" fill="#909090"/></svg>`
};
